export enum Errors {
  maxFileSize = 'APPLICATION.ERRORS.MAX_FILE_SIZE',
  required = 'APPLICATION.ERRORS.REQUIRED',
  length = 'APPLICATION.ERRORS.LENGTH',
  maxLength = 'APPLICATION.ERRORS.MAX_LENGTH',
  email = 'APPLICATION.ERRORS.EMAIL',
  max = 'APPLICATION.ERRORS.MAX',
  min = 'APPLICATION.ERRORS.MIN',
  pattern = 'APPLICATION.ERRORS.PATTERN'
}
